export default "__VITE_ASSET__SHIDonBK__"